// extracted by mini-css-extract-plugin
export var parcelRow = "_ux-0";